import { format, parseISO } from 'date-fns';

export const toUTC = (date: Date): Date =>
    new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
    );

// A date-time with no zone designator (e.g. a .NET DateTime read back from the
// database) is UTC. parseISO would read it as local time, so mark it UTC first.
// Date-only strings are left alone and stay local midnight.
const hasTimeWithoutOffset = (date: string): boolean =>
    date.includes('T') && !/(Z|[+-]\d{2}(:?\d{2})?)$/i.test(date);

export const fromUTC = (date: string | Date): Date =>
    typeof date === 'string'
        ? parseISO(hasTimeWithoutOffset(date) ? `${date}Z` : date)
        : new Date(date);

export const formatDate = (date?: Date | string): string => {
    if (!date) return '';
    const parsedDate = typeof date === 'string' ? parseISO(date) : date;
    return format(parsedDate, 'yyyy-MM-dd');
};

export const formatDateMonthYear = (date?: Date | string): string => {
    if (!date) return '';
    const parsedDate = typeof date === 'string' ? parseISO(date) : date;
    return format(parsedDate, 'dd.MM.yyyy');
};

export const formatDateTime = (date?: Date | string): string => {
    if (!date) return '';
    const parsedDate = typeof date === 'string' ? parseISO(date) : date;
    return format(parsedDate, 'yyyy-MM-dd HH:mm');
};
